// extracted by mini-css-extract-plugin
module.exports = {"badgesContainer":"AL","badge":"AM","ratingLabel":"AN","subHeader":"AO","genre":"AP","rating":"AQ"};